/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Architect_Output9Inputs */

const en_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix plan`)
};

const ar_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطة الإصلاح`)
};

const bn_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিক্স পরিকল্পনা`)
};

const de_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix-Plan`)
};

const es_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan de corrección`)
};

const fr_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan de correction`)
};

const pt_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de correção`)
};

const zh_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修复计划`)
};

const tr_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzeltme planı`)
};

const ru_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`План исправлений`)
};

const pl_svc_ai_app_rescue_architect_output9 = /** @type {(inputs: Svc_Ai_App_Rescue_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan naprawy`)
};

/**
* | output |
* | --- |
* | "Fix plan" |
*
* @param {Svc_Ai_App_Rescue_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_architect_output9 = /** @type {((inputs?: Svc_Ai_App_Rescue_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_architect_output9(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_architect_output9(inputs)
	return en_svc_ai_app_rescue_architect_output9(inputs)
});
export { svc_ai_app_rescue_architect_output9 as "svc_ai-app-rescue_ARCHITECT_output" }